import "./Order.scss";
import { useTranslation } from "react-i18next";
import defaultContent from "../../../../../../content/customers";
import profileContent from "../../../../../../content/profile";
import commonContent from "../../../../../../content/common";
import LeafDateTime from "../../../../../../common/leaf/LeafDateTime/LeafDateTime";
import type { CustomerOrder } from "../../../../../../services/Customer/CustomerOrderList/customerOrderListAPI.types";
import { LeafPV } from "../../../../../../common/leaf/LeafFormat/LeafPV/LeafPV";
import { LeafBV } from "../../../../../../common/leaf/LeafFormat/LeafBV/LeafBV";
import { useAppSelector } from "../../../../../../store";
import { getDisplayName } from "../../../../../../common/util/displayName";
import OrderType from "./OrderType/OrderType";

type Props = {
  order: CustomerOrder;
  isCompact?: boolean;
  orderIndex: number;
  showVCSOrderTag: boolean;
};

const Order = (props: Props) => {
  const { order, isCompact, orderIndex, showVCSOrderTag } = props;
  const { DisplayName, PrivacyFlag, OrderNumber, Date, PV, BV, VcsFlag, VcsReasons, Source, AboNo } = order;

  const isConfidentialView = useAppSelector(({ profile }) => profile.confidentialView);
  const isConfidentialCustomer = useAppSelector(({ profile }) => profile.isConfidentialCustomer) ?? false;
  const { t } = useTranslation(["customers", "profile"]);

  const resolvedName = getDisplayName(DisplayName, t);

  return (
    <div className={`order ${isCompact ? "order--compact" : ""}`}>
      <div className="order__content">
        <div className="order__header order__display--mobile">
          <div className="order__order-date">
            <LeafDateTime
              date={Date}
              options={{ month: "long", day: "numeric", year: "numeric" }}
              ignoreTimeZone={true}
            />
          </div>
          <div className="order__order-number">
            {`${t("order", defaultContent["order"])}`} #{OrderNumber}
          </div>
        </div>
        <div className="order__abo-name">
          {isConfidentialView ? (
            isConfidentialCustomer ? (
              `${t("common:confidentialUser", commonContent["confidentialUser"])}`
            ) : (
              `${t("customerProfile.newCustomer", profileContent["customerProfile"]["newCustomer"], { ns: "profile" })}`
            )
          ) : (
            <span>{PrivacyFlag ? resolvedName : `${resolvedName} #${AboNo}`}</span>
          )}
        </div>
        <div className="order__order-date order__display--desktop">
          <LeafDateTime
            date={Date}
            options={{ month: "long", day: "numeric", year: "numeric" }}
            ignoreTimeZone={true}
          />
        </div>
        <div className="order__order-number order__display--desktop">#{OrderNumber}</div>
        <div className="order__footer">
          <div className="order__pv">
            <span className="order__pv-value">
              <LeafPV pv={PV} />
            </span>
            <span className="order__display">
              &nbsp;
              {showVCSOrderTag && VcsFlag === true
                ? `${t("vcsPv", defaultContent["vcsPv"])}`
                : `${t("pv", defaultContent["pv"])}`}
            </span>
          </div>
          <div className="order__bv order__bv__right order__display--desktop">
            <LeafBV bv={BV} />
          </div>
          <div className="order__order-type">
            <OrderType
              vcsFlag={VcsFlag}
              source={Source}
              vcsReasons={VcsReasons}
              isCompact={isCompact}
              orderIndex={orderIndex}
              orderDate={Date}
              showVCSOrderTag={showVCSOrderTag}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Order;
